import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

const makeCertificatePdfUrl = (certificateId: string) => `https://api.kenzie.com.br/v1/teaching/certificates/${certificateId}`;
const alternativePdfUrl = (certificateId: string) => `http://35.184.127.130/students/certificates/${certificateId}`;

const Certificate = () => {
  const router = useRouter();
  const [pdfUrl, setPdfUrl] = useState('');
  const certificateId = router.query.id as string;

  useEffect(() => {
    if (!certificateId || !router.isReady) {
      return;
    }

    const url = makeCertificatePdfUrl(certificateId);

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Error fetching certificate');
        }
        return response;
      })
      .then(() => setPdfUrl(url))
      .catch(() => setPdfUrl(alternativePdfUrl(certificateId)));
  }, [certificateId, router.isReady]);

  if (!pdfUrl) {
    return null; // Or some loading indicator
  }

  return (
    <main style={{ height: '100vh', overflow: 'hidden' }}>
      <iframe src={pdfUrl} width="100%" height="100%" />
    </main>
  );
};

export default Certificate;
